import { UiSchema } from "@rjsf/utils/lib/types";
// MODIFICATIONS
// einige Fragen wurden nun fs_got_product utnergeordnet
//       fs_got_product: {
//         got_which_product: {
//         fs_application: {
//         fs_workshop_urge_reflex: {
//           urge_reflex_nausea: {
//           urge_reflex_real_imagined: {
// },

export const postsurveyUiSchema = (t: (s: string) => string): UiSchema => {
  return {
    start: {
      "ui:field": "HtmlDescriptionField",
    },
    contact_id: {
      "ui:widget": "hidden",
    },
    info_id: {
      "ui:widget": "hidden",
    },
    intro: {
      "ui:widget": "hidden",
    },
    original: {
      "ui:widget": "hidden",
    },
    cpap: {
      "ui:widget": "hidden",
    },
    osas_des: {
      "ui:widget": "hidden",
    },
    // },
    p_base: {
      "ui:title": "",
      state_no_product_received: {
        "ui:widget": "hidden",
      },
      state_no_product_recived_or_applicable: {
        "ui:widget": "hidden",
      },
      fs_which_product: {
        fs_which_product_title: {
          "ui:field": "HtmlTitleField",
        },
        which_product: {
          "ui:widget": "radio",
          "ui:enumNames": ["Velumount Original (offene Spange)", "Velumount Intro (Ring)"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_got_product: {
        fs_got_product_title: {
          "ui:field": "HtmlTitleField",
        },
        got_product: {
          "ui:widget": "radio",
          "ui:enumNames": ["Ja, ich habe eine Spange erhalten.", "Nein, ich habe keine Spange erhalten."],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        got_which_product: {
          "ui:widget": "radio",
          "ui:enumNames": ["Velumount Original (offene Spange)", "Velumount Intro (Ring)"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_application: {
        fs_application_title: {
          "ui:field": "HtmlTitleField",
        },

        sleep: {
          "ui:widget": "radio",
          "ui:enumNames": ["Ja", "Nein"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        wellbeing: {
          "ui:widget": "radio",
          "ui:enumNames": ["Ja", "Nein"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        how_often: {
          "ui:widget": "radio",
          "ui:enumNames": ["fast immer", "oft", "manchmal", "selten", "nie"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_workshop_urge_reflex: {
        fs_workshop_urge_reflex_title: {
          "ui:field": "HtmlTitleField",
        },
        urge_reflex_nausea: {
          "ui:widget": "radio",
          "ui:enumNames": [
            "Praktisch nicht vorhanden",
            "Nur leicht vorhanden",
            "Vorhanden, aber überwindbar",
            "Stark, aber gerade noch überwindbar",
            "Nicht überwindbar",
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        urge_reflex_real_imagined: {
          "ui:widget": "radio",
          "ui:enumNames": ["Schwächer als erwartet", "Etwa wie erwartet", "Stärker als erwartet"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_why_not: {
        "ui:title": "",
        why_no_sleep: {
          "ui:widget": "checkboxes",
          "ui:enumNames": ["Zu starker Würgereiz", "Schmerzen beim Tragen", "Zu enge Verhältnisse im Rachen", "Weitere..."],
        },
      },
    },
    p_consolidation_users_only: {
      "ui:order": ["fs_habituation_period", "fs_snoring", "fs_osas", "fs_cpap_using_2"],

      fs_habituation_period: {
        fs_habituation_period_title: {
          "ui:field": "HtmlTitleField",
        },
        duration_habituation: {
          "ui:widget": "radio",
          "ui:enumNames": [
            "Ich schlief bereits in der ersten Nacht mit dem Velumount Produkt",
            "1-3 Nächte",
            "ca. 1 Woche",
            "ca. 2-3 Wochen",
            "länger",
            "ich weiss es nicht",
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        relaxed_2: {
          "ui:widget": "radio",
          "ui:enumNames": ["fast immer", "oft", "manchmal", "selten", "nie"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_snoring: {
        fs_snoring_title: {
          "ui:field": "HtmlTitleField",
        },

        snoring_observed: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              { value: "never", label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.columns.never") },
              {
                value: "sometimes",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.columns.sometimes"),
              },
              { value: "2 hours", label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.columns.2hours") },
              { value: "4 hours", label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.columns.4hours") },
              { value: "always", label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.columns.always") },
              { value: "unknown", label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.columns.unknown") },
            ],
            rows: [
              {
                value: "snoring_observed_0",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.rows.snoring_observed_0"),
              },
              {
                value: "snoring_observed_1",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.rows.snoring_observed_1"),
              },
            ],
          },
        },

        self_assess_suffer_2: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              {
                value: "well bearable",
                label: t("survey.custom.assess_suffer.columns.well bearable"),
              },
              {
                value: "rather well bearable",
                label: t("survey.custom.assess_suffer.columns.rather well bearable"),
              },
              { value: "medium", label: t("survey.custom.assess_suffer.columns.medium") },
              {
                value: "rather unbearable",
                label: t("survey.custom.assess_suffer.columns.rather unbearable"),
              },
              { value: "unbearable", label: t("survey.custom.assess_suffer.columns.unbearable") },
            ],
            rows: [
              {
                value: "self_assess_suffer_2_0",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.rows.snoring_observed_0"),
              },
              {
                value: "self_assess_suffer_2_1",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.rows.snoring_observed_1"),
              },
            ],
          },
        },
        suffer_person_concerned_2: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              {
                value: "well bearable",
                label: t("survey.custom.assess_suffer.columns.well bearable"),
              },
              {
                value: "rather well bearable",
                label: t("survey.custom.assess_suffer.columns.rather well bearable"),
              },
              { value: "medium", label: t("survey.custom.assess_suffer.columns.medium") },
              {
                value: "rather unbearable",
                label: t("survey.custom.assess_suffer.columns.rather unbearable"),
              },
              { value: "unbearable", label: t("survey.custom.assess_suffer.columns.unbearable") },
            ],
            rows: [
              {
                value: "suffer_person_concerned_2_0",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.rows.snoring_observed_0"),
              },
              {
                value: "suffer_person_concerned_2_1",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.rows.snoring_observed_1"),
              },
            ],
          },
        },
      },
      fs_osas: {
        fs_osas_title: {
          "ui:field": "HtmlTitleField",
        },
        improved_sleep_with_velumount: {
          "ui:widget": "radio",
          "ui:enumNames": ["Ja", "Nein"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        evaluation_sleep: {
          "ui:widget": "radio",
          "ui:enumNames": ["Ja", "Nein"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        result_evaluation_sleep_efficacy: {
          "ui:widget": "radio",
          "ui:enumNames": ["Sehr schlechter", "schlecht", "Teils/Teils", "Gut", "Sehr gut"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        results_evaluation_sleep: {
          "ui:widget": "radio",
          "ui:enumNames": ["Schlechter", "Gleich", "Besser", "Viel besser", "Ich hatte keine Voruntersuchung ohne Velumount Produkt"],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_cpap_using_2: {
        fs_cpap_using_2_title: {
          "ui:field": "HtmlTitleField",
        },
        sleep_quality: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              { value: "1", label: 1 },
              { value: "2", label: 2 },
              { value: "3", label: 3 },
              { value: "4", label: 4 },
              { value: "5", label: 5 },
              { value: "6", label: 6 },
              { value: "7", label: 7 },
              { value: "8", label: 8 },
              { value: "9", label: 9 },
              { value: "10", label: 10 },
            ],
            rows: [
              {
                value: "sleep_quality_cpap_quality_sleep",
                label: t(
                  "survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.sleep_quality.rows.sleep_quality_cpap_quality_sleep"
                ),
              },
              {
                value: "sleep_quality_velumount_quality_sleep",
                label: t(
                  "survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.sleep_quality.rows.sleep_quality_velumount_quality_sleep"
                ),
              },
            ],
          },
        },

        life_quality: {
          "ui:field": "MatrixField",
          "ui:options": {
            columns: [
              { value: "1", label: 1 },
              { value: "2", label: 2 },
              { value: "3", label: 3 },
              { value: "4", label: 4 },
              { value: "5", label: 5 },
              { value: "6", label: 6 },
              { value: "7", label: 7 },
              { value: "8", label: 8 },
              { value: "9", label: 9 },
              { value: "10", label: 10 },
            ],
            rows: [
              {
                value: "life_quality_cpap_quality_life",
                label: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.life_quality.rows.life_quality_cpap_quality_life"),
              },
              {
                value: "life_quality_velumount_quality_life",
                label: t(
                  "survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.life_quality.rows.life_quality_velumount_quality_life"
                ),
              },
            ],
          },
        },
        cpap_using_current_2: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.cpap_using_current_2.enums.always (6-7 times per week)"),
            t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.cpap_using_current_2.enums.often (ca. 2-5 times per week)"),
            t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.cpap_using_current_2.enums.rarly (less than 2 times per week)"),
            t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.cpap_using_current_2.enums.never, but i keep the cpap at home"),
            t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.cpap_using_current_2.enums.never, i retourned the cpap"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
    },
    p_consolidation_all_users: {
      "ui:title": "",
      fs_fall_asleep_2: {
        epworth_title: {
          "ui:field": "HtmlTitleField",
        },
        epworth_description: {
          "ui:field": "HtmlDescriptionField",
        },
        epworth: {
          epworth: {
            "ui:field": "MatrixField",
            "ui:options": {
              columns: [
                { value: "0", label: t("survey.custom.epworth.columns.niemals_einschlafen") },
                { value: "1", label: t("survey.custom.epworth.columns.kaum_einschlafen") },
                { value: "2", label: t("survey.custom.epworth.columns.moeglicherweise_einschlafen") },
                { value: "3", label: t("survey.custom.epworth.columns.wahrscheinlich_einschlafen") },
              ],
              rows: [
                { value: "Sitting and readin", label: t("survey.custom.epworth.rows.Sitting and readin") },
                { value: "Watching TV", label: t("survey.custom.epworth.rows.Watching TV") },
                {
                  value: "Sitting, inactive in a public place",
                  label: t("survey.custom.epworth.rows.Sitting, inactive in a public place"),
                },
                {
                  value: "As a passenger in a car for an hour without break",
                  label: t("survey.custom.epworth.rows.As a passenger in a car for an hour without break"),
                },
                {
                  value: "Lying down to rest in the afternoon",
                  label: t("survey.custom.epworth.rows.Lying down to rest in the afternoon"),
                },
                { value: "Sitting an talking to someone", label: t("survey.custom.epworth.rows.Sitting an talking to someone") },
                {
                  value: "Sitting quietly after lunch without alcohol",
                  label: t("survey.custom.epworth.rows.Sitting quietly after lunch without alcohol"),
                },
                {
                  value: "In a car while stopped for a few minutes in the traffic",
                  label: t("survey.custom.epworth.rows.In a car while stopped for a few minutes in the traffic"),
                },
              ],
            },
          },
        },
      },
    },
    p_consolidation_all_users_2: {
      "ui:title": "",
      state_no_product_applicable: {
        "ui:widget": "hidden",
      },
      fs_qm_instructor: {
        fs_qm_instructor_title: {
          "ui:field": "HtmlTitleField",
        },
        qm_instructor_appearance: {
          "ui:field": "SliderField",
          "ui:options": {
            startLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_appearance.startLabel"),
            endLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_appearance.endLabel"),
          },
        },
        qm_instructor_how_answered_questions: {
          "ui:field": "SliderField",
          "ui:options": {
            startLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_how_answered_questions.startLabel"),
            endLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_how_answered_questions.endLabel"),
          },
        },
        qm_instructor_competence: {
          "ui:field": "SliderField",
          "ui:options": {
            startLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_competence.startLabel"),
            endLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_competence.endLabel"),
          },
        },
      },
      fs_qm_service: {
        "ui:order": ["fs_qm_service_title", "qm_service", "qm_was_group_ws", "qm_group_ws_fell", "qm_ambiance", "qm_duration_ws"],

        fs_qm_service_title: {
          "ui:field": "HtmlTitleField",
        },
        qm_service: {
          "ui:field": "SliderField",
          "ui:options": {
            startLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_service.startLabel"),
            endLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_service.endLabel"),
          },
        },

        qm_was_group_ws: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_was_group_ws.yes"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_was_group_ws.no"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
        qm_group_ws_fell: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_group_ws_fell.positive"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_group_ws_fell.neutral"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_group_ws_fell.negative"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },

        qm_ambiance: {
          "ui:field": "SliderField",
          "ui:options": {
            startLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_ambiance.startLabel"),
            endLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_ambiance.endLabel"),
          },
        },
        qm_duration_ws: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_duration_ws.3_4_std"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_duration_ws.1_std"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_duration_ws.1_1_4_std"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_duration_ws.1_1_2_std"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_duration_ws.2_std_und_mehr"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      fs_qm_recommend: {
        fs_qm_recommend_title: {
          "ui:field": "HtmlTitleField",
        },

        qm_recommend_us: {
          "ui:field": "SliderField",
          "ui:options": {
            startLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_recommend.qm_recommend_us.startLabel"),
            endLabel: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_recommend.qm_recommend_us.endLabel"),
          },
        },
      },

      // textarea
      fs_comment: {
        comment: {
          "ui:widget": "textarea",
          "ui:options": {
            rows: 5,
          },
        },
      },
      fs_reaction: {
        reaction_ok: {
          "ui:widget": "radio",
          "ui:enumNames": [
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_was_group_ws.yes"),
            t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_was_group_ws.no"),
          ],
          "ui:options": {
            classNames: "vertical-aligned-items",
          },
        },
      },
      // finalTitle: {
      //   "ui:field": "HtmlTitleField",
      // },
      finalDescription: {
        "ui:field": "HtmlDescriptionField",
      },

      // fs_break: {
      // breakTitle: {
      //   "ui:field": "HtmlTitleField",
      // },
      breakDescription: {
        "ui:field": "HtmlDescriptionField",
      },
      // },
    },

    // final: {
    ess_initial: {
      "ui:widget": "hidden",
    },
    ess_new: {
      "ui:widget": "hidden",
    },
    ess_diff: {
      "ui:widget": "hidden",
    },
  };
};
